export const EXPORT_FORMATS = [
  { id: "xlsx", label: "Excel (.xlsx)" },
  { id: "csv", label: "CSV (.csv)" },
];

export const DEFAULT_EXPORT_FORMAT = "xlsx";
